export default __webpack_public_path__ + "static/media/fundoSuvinil.b0232c31.jpg";